import React, { useContext, useEffect, useState } from "react";

import { EnquiryContext } from "venuescanner-js/react/components/Inbox/context/EnquiryContext";
import { ViewContext } from "venuescanner-js/react/components/Inbox/context/ViewContext";
import { leadStatus } from "venuescanner-js/constants/thread";

import Lead from "venuescanner-js/react/components/Inbox/components/Leads/Lead";
import LeadAwaitingLeads from "venuescanner-js/react/components/Inbox/components/Leads/LeadAwaitingLeads";
import LeadsPanel from "venuescanner-js/react/components/Inbox/components/Leads/LeadsPanel";
import LeadsNotificationSettings from "venuescanner-js/react/components/Inbox/components/Leads/LeadsNotificationSettings";

const Leads = () => {
  const { hostLeads, missedLeads } = useContext(EnquiryContext);
  const { isMobileDevice } = useContext(ViewContext);
  const [activeFilter, setActiveFilter] = useState({
    name: "all",
    status: null,
    count: hostLeads.length,
  });
  const [showMissedLeads, setShowMissedLeads] = useState(null);
  const [showNotificationSettings, setShowNotificationSettings] =
    useState(false);

  const countLeadType = (type) => {
    const filterLeadsByType = [...hostLeads].filter(
      (item) => item._subjects._value.lead.status === type
    );
    return filterLeadsByType.length;
  };

  const newCount = countLeadType(leadStatus.OPEN);
  const pendingCount = countLeadType(leadStatus.INTERESTED);

  const filterOptions = [
    { name: "all", status: null, count: hostLeads.length },
    { name: "new", status: leadStatus.OPEN, count: newCount },
    { name: "pending", status: leadStatus.INTERESTED, count: pendingCount },
    { name: "missed", list: missedLeads, count: missedLeads.length },
  ];

  const filterList = filterOptions.map((filter) => (
    <span
      key={filter.name}
      className={`leads__filter__item p ${
        activeFilter.name === filter.name ? "isActive" : ""
      } ${!filter.count ? "isEmpty" : ""}`}
      onClick={() => changeFilter(filter)}
    >
      {filter.name}
    </span>
  ));
  const leadsList = showMissedLeads
    ? missedLeads
        .sort(
          (a, b) =>
            b._subjects._value.admin_event.budget -
            a._subjects._value.admin_event.budget
        )
        .map((lead) => (
          <Lead key={lead.data()._id} lead={lead} activeFilter={activeFilter} />
        ))
    : hostLeads
        .sort(
          (a, b) =>
            b._subjects._value.admin_event.budget -
            a._subjects._value.admin_event.budget
        )
        .map((lead) => (
          <Lead key={lead.data()._id} lead={lead} activeFilter={activeFilter} />
        ));

  const changeFilter = (filter) => {
    setActiveFilter(filter);
  };

  return hostLeads?.length ? (
    <div className={`leads inbox__section`}>
      {isMobileDevice && <LeadsPanel />}
      <div className="leads__header">
        <div className="leads__filter">
          <div className="leads__filter__wrapper">{filterList}</div>
        </div>
        <div className="leads__settings">
          <span
            className="leads__settings__notifications p"
            onClick={() =>
              setShowNotificationSettings(!showNotificationSettings)
            }
          >
            MatchLead email settings
          </span>
          <a
            href="https://intercom.help/venuescannercom/en/articles/5433271-introducing-matchleads"
            target="_blank"
            className="leads__settings__more-info"
            rel="noreferrer"
          >
            <p className="leads__more-info__copy">More info</p>
          </a>
        </div>
      </div>
      <div className="leads__list">
        {!isMobileDevice && (
          <div className="leads__list__row leads__list__row--header">
            <span className="p">Venue</span>
            <span className="p">Event type</span>
            <span className="p">Date</span>
            <span className="p">Budget</span>
          </div>
        )}
        {leadsList}
      </div>
      {showNotificationSettings && (
        <LeadsNotificationSettings
          handleClose={() => setShowNotificationSettings(false)}
        />
      )}
    </div>
  ) : (
    <div className={`leads leads__constrain-overflow inbox__section`}>
      <LeadAwaitingLeads />
    </div>
  );
};

export default Leads;
